import { render } from "./Edit.vue?vue&type=template&id=fd5f6dd8&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=fd5f6dd8&lang=scss&scoped=true"
import "./Edit.vue?vue&type=style&index=1&id=fd5f6dd8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5f6dd8"]])

export default __exports__